import { ReactNode } from "react";

interface LoginRouteGuardProps {
  children: ReactNode;
}

// La pagina di login è sempre accessibile — nessun redirect automatico.
const LoginRouteGuard = ({ children }: LoginRouteGuardProps) => {
  return <>{children}</>;
};

export default LoginRouteGuard;
